const ALPHABET = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
const BASE = 62n;
const MAX_DRIVER_TOKEN = 0xffffffffffffffffn;

export function encodeDriverToken(token: string): string | null {
  const hex = String(token ?? '').trim().toLowerCase();
  if (!/^[0-9a-f]{16}$/.test(hex)) return null;

  let value = BigInt(`0x${hex}`);
  let code = '';
  do {
    code = ALPHABET[Number(value % BASE)] + code;
    value /= BASE;
  } while (value > 0n);
  return code.padStart(11, ALPHABET[0]);
}

export function decodeDriverToken(code: string | undefined): string | null {
  const value = String(code ?? '').trim();
  if (!/^[a-zA-Z0-9]{11}$/.test(value)) return null;

  let number = 0n;
  for (const character of value) {
    number = number * BASE + BigInt(ALPHABET.indexOf(character));
  }
  if (number > MAX_DRIVER_TOKEN) return null;
  return number.toString(16).padStart(16, '0');
}
